export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Security First',
      description: 'Built with industry-leading security protocols to protect your data and privacy at all times.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Performance Optimized',
      description: 'Engineered for speed and efficiency, ensuring smooth operation without draining your battery.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User Privacy',
      description: 'We respect your privacy. No data collection, no tracking, just pure functionality you can trust.'
    }
  ];

  return (
    <section className="py-32 bg-[#F7F7F7]">
      <div className="max-w-[1440px] mx-auto px-20">
        <div className="grid grid-cols-3 gap-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-6">
                <i className={`${feature.icon} text-6xl text-[#4A9FFF]`}></i>
              </div>
              <h4 className="text-3xl font-semibold text-[#1A1A1A] mb-4">
                {feature.title}
              </h4>
              <p className="text-base text-[#666666] leading-relaxed max-w-[280px] mx-auto">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}